import React, { useState, useEffect, useRef } from 'react';
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { Typewriter } from 'react-simple-typewriter';
import { BackendLink } from '../../../Components';
import './NewsHeaderSec.css';

const NewsHeaderSec = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isTransitioning, setIsTransitioning] = useState(false);
    const [fadeOut, setFadeOut] = useState(false);
    const [carouselData, setCarouselData] = useState([]);
    const [error, setError] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const totalSlides = carouselData.length;
    const carouselRef = useRef(null);

    useEffect(() => {
        const fetchNewsData = async () => {
            try {
                const response = await fetch(`${BackendLink}/AllNews/`);
                const data = await response.json();

                const importantNews = data.filter(news => news.important);
                setCarouselData(importantNews);

                if (importantNews.length === 0) {
                    setError(true);
                }
            } catch (error) {
                console.error('Error fetching news:', error);
                setError(true);
            } finally {
                setIsLoading(false);
            }
        };

        fetchNewsData();
    }, []);

    const handleNext = () => {
        if (isTransitioning || currentIndex === totalSlides - 1) return;
        setIsTransitioning(true);
        triggerFadeOut();
        setTimeout(() => {
            setCurrentIndex((prevIndex) => prevIndex + 1);
            setIsTransitioning(false);
        }, 300);
    };

    const handlePrev = () => {
        if (isTransitioning || currentIndex === 0) return;
        setIsTransitioning(true);
        triggerFadeOut();
        setTimeout(() => {
            setCurrentIndex((prevIndex) => prevIndex - 1);
            setIsTransitioning(false);
        }, 300);
    };

    useEffect(() => {
        if (carouselRef.current) {
            carouselRef.current.style.transition = "transform 0.5s ease-in-out";
            carouselRef.current.style.transform = `translateX(-${currentIndex * 100}%)`;
            triggerFadeIn();
        }
    }, [currentIndex]);

    const triggerFadeOut = () => {
        setFadeOut(true);
        setTimeout(() => {
            setFadeOut(false);
        }, 250);
    };

    const triggerFadeIn = () => {
        setTimeout(() => {
            setFadeOut(false);
        }, 250);
    };

    if (isLoading) {
        return <div className="black-screen">Loading...</div>;
    }

    if (error) {
        return <div className="black-screen">⚠️ Server Down Or No Data</div>;
    }

    return (
        <div className="imgCarouselWrapper">
            <div className="imgCarousel" ref={carouselRef}>
                {carouselData.map((item, index) => (
                    <div
                        key={index}
                        className="carouselSlide"
                        style={{ backgroundImage: `url(${item.image})` }}
                    ></div>
                ))}
            </div>
            <div
                className="content-wrapper"
                data-aos="fade-up"
                data-aos-duration="500"
            >
                <div className={`carousel-title ${fadeOut ? 'fade' : ''}`}>
                    {carouselData[currentIndex]?.title}
                </div>
                <div className="carousel-paragraph">
                    {carouselData[currentIndex] && (
                        <Typewriter
                            key={currentIndex}
                            words={[
                                carouselData[currentIndex].paragraph.slice(0, 200).trim() + '...',
                            ]}
                            loop={1}
                            cursor
                            cursorStyle="|"
                            typeSpeed={30}
                            deleteSpeed={0}
                            delaySpeed={1000}
                        />
                    )}
                </div>
                <div className="carousel-buttons">
                    <button
                        className="carousel-btn btn-right"
                        onClick={handlePrev}
                        disabled={currentIndex === 0}
                    >
                        <IoIosArrowBack />
                    </button>
                    <button
                        className="carousel-btn btn-left"
                        onClick={handleNext}
                        disabled={currentIndex === totalSlides - 1}
                    >
                        <IoIosArrowForward />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default NewsHeaderSec;
